import { defineComponent as _defineComponent } from 'vue'
import { IBankList } from '@/modules/onboarding/services';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonBoxIcon,
  Heading,
  InitialAvatarImage,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { computed, inject, ref, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BankStep',
  setup(__props) {

const bankList = inject('bankList') as Ref<IBankList>;
const updateBank = inject('updateBank', (value?: string) => ({
  value
}));
const getWithdrawReview = inject('fetchWithdrawReview', async () => {});

const isLoading = ref(false);

const formattedBankList = computed(() => {
  if (!bankList) return [];

  return [
    {
      label: bankList.value.warrenBankAccount.label,
      bankAccounts: [bankList.value.warrenBankAccount.bankAccount]
    },
    {
      label: bankList.value.externalBankAccounts.label,
      bankAccounts: bankList.value.externalBankAccounts.bankAccounts
    }
  ];
});

async function fetchWithdrawReview(bankId?: string) {
  updateBank(bankId);

  try {
    isLoading.value = true;

    await getWithdrawReview();
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,bankList, updateBank, getWithdrawReview, isLoading, formattedBankList, fetchWithdrawReview, NebraskaColors, BaseText, ButtonBoxIcon, Heading, InitialAvatarImage, LoaderIndicator }
}

})